module.exports = __webpack_public_path__ + "img/19_69.e05c7bf6.png";